import gql from "graphql-tag";

export default gql`
  query Deployments(
    $offset: Int
    $limit: Int
    $customerId: ID
    $orderByRecordingDate: String
    $orderByCodename: String
    $description: String
    $hasSecondCoach: Boolean
  ) {
    deployments(
      offset: $offset
      limit: $limit
      customerId: $customerId
      orderByRecordingDate: $orderByRecordingDate
      orderByCodename: $orderByCodename
      description: $description
      hasSecondCoach: $hasSecondCoach
    ) {
      items {
        id
        codename
        secondCoachUrl
        proxyPtz {
          protocol
          hostname
          port
        }
        description
        place {
          name
          address
        }
      }
      total
    }
  }
`;
